import jq from 'jquery';
import _ from 'ext:lodash';
import Framework from 'framework';
import constants from 'lib/constants';
import authUtils from 'lib/auth-utils';

const POST = 'POST';
const authPath = 'login';
const timeout = 30000;
// Export Value
let contract = {};

function getBaseUrl() {
	let apiUrl = authUtils.isFeatureFlagEnabled(constants.authV2FeatureFlagId) ? constants.apiAuthUrlV2 : constants.apiAuthUrl;
	return Framework.global.lt.api.apimUrl + apiUrl;
}

function getSubscriptionKey() {
	return Framework.global.lt.api.apimKey;
}

function authenticationServiceUrl(resourcePath) {
	return getBaseUrl() + (resourcePath ? resourcePath : '');
}

function headers() {
	return {
		'Ocp-Apim-Subscription-Key': getSubscriptionKey(),
		'Ocp-Apim-Trace': true,
		'Content-Type': 'application/json; charset=UTF-8'
	};
}

function ajaxCall(method, data, resourcePath) {
	return $.ajax({
		url: contract.getUrl(resourcePath),
		method: method,
		async: false,
		timeout: timeout,
		crossDomain: true,
		headers: contract.getHeaders(),
		dataType: 'json',
		data: JSON.stringify(data)
	});
}

const authenticationService = {
	authenticate(username, password){
		var callMethod = POST;
		var inputData = { 'username': username, 'password': password };
		return new Promise((resolve, reject)=> {
			contract.ajaxCaller(callMethod, inputData, authPath)
				.then(
					// Success
					(data, textStatus) => {
						resolve(data);
					},
					// Failure
					(jqXHR, textStatus, errorThrown) => {
						if(jqXHR.status === 400 || jqXHR.status === 500 ) {
							resolve(jqXHR.responseJSON);
						} else{
							reject(errorThrown);
						}
					});
		});
	}
};

contract = {
	api: authenticationService,
	ajaxCaller: ajaxCall,
	getHeaders: headers,
	getUrl: authenticationServiceUrl
};

export default contract;
